export const kebabToCamel = (test: string) => test?.replace(/(-[a-z])/gi, (group) => group[1].toUpperCase()) || test;
